import styled, { css } from 'styled-components';
import {
  SYS_SPACE_FIXED_50,
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_200,
  SYS_BREAKPOINT_MD,
} from '@oneaudi/unified-web-common';

export const LinkButtonContainer = styled.div`
  margin-top: ${SYS_SPACE_FIXED_100};
  & > button {
    padding: 0px 0px;
    justify-content: flex-start;
  }
`;

export const ConsumptionEmissionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: ${SYS_SPACE_FIXED_100};
  align-self: stretch;
`;
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  row-gap: 10px;
  margin-bottom: ${SYS_SPACE_FIXED_200};
`;

export const FavoritesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-left: ${SYS_SPACE_FIXED_50};
`;

export const FavoritesOverlay = styled.div`
  position: absolute;
  z-index: 13;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);

  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
`;

const GridButtonStyles = css`
  width: 90%;
  display: flex;
  flex-flow: column;
  align-items: flex-start;

  button {
    width: 100%;
  }
`;

export const GridButtonContainer = styled.div`
  ${GridButtonStyles}
`;

export const ListButtonContainer = styled.div`
  ${GridButtonStyles}

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: auto;
    display: grid;
    column-gap: ${SYS_SPACE_FIXED_50};
    grid-template-columns: 1fr 1fr;
    align-items: self-start;

    button {
      width: auto;
    }
  }
`;
